<template>
  <div class="widget" v-if="hasFriendRequest">
    <div class="widget-body bordered-top bordered-sky friend-request">
      <div class="card" v-for="request in friendRequest" :key="request.user_id">
        <div class="user-heading">
          <a href="#"><img src="img/Friends/guy-3.jpg" alt="" /></a>
          <h5>{{ request.given_name }}</h5>
          <div class="buttons">
            <button class="btn btn-sm btn-azure btn-icon" @click="acceptFriendRequest(request.user_id)">
              <i class="fa fa-check">Agree</i>
            </button>
            <button class="btn btn-sm btn-icon">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const friendRequest = ref([]);
    onMounted(async () => {
      await store.dispatch("friend/getFriendRequests");
      friendRequest.value = store.getters["friend/getFriendRequests"];
    });
    async function acceptFriendRequest(userId) {
      await store.dispatch("friend/acceptFriendRequest", { userId });
    }
    const hasFriendRequest = computed(() => {
      return friendRequest.value.length > 0;
    });
    return {
      friendRequest,
      hasFriendRequest,
      acceptFriendRequest,
    };
  },
};
</script>

<style scoped>
.card {
  padding-right: 20px;
}
.friend-request {
  display: flex;
  overflow-x: scroll;
}
.friend-request .card:last-child {
  padding-right: 0;
}
.user-heading img {
  width: 150px;
}
.user-heading h5 {
  display: block;
  text-align: center;
}
.user-heading .buttons {
  display: flex;
  justify-content: space-between;
}
</style>